export function hasGalleryPermission(permissions, required) {
  if (!required) {
    return true;
  }

  if (!permissions || typeof permissions !== "object") {
    return false;
  }

  const requiredList = Array.isArray(required) ? required : [required];

  return requiredList.every((key) => {
    if (typeof key !== "string" || !key) {
      return false;
    }

    const parts = key.split(".");
    let current = permissions;
    for (const part of parts) {
      if (!current || typeof current !== "object" || !(part in current)) {
        return false;
      }
      current = current[part];
    }
    return Boolean(current);
  });
}

export function canAccessGalleryPermission(session, required, galleryId) {
  if (!session) {
    return false;
  }

  const sessionType = (session.user_type || "").toLowerCase();
  if (sessionType === "gallery") {
    if (!galleryId || session._id === galleryId) {
      return true;
    }
    return false;
  }

  if (!session.gallery_id) {
    return false;
  }

  if (galleryId && session.gallery_id !== galleryId) {
    return false;
  }

  const status = session.gallery_member?.status ?? "accepted";
  if (status !== "accepted") {
    return false;
  }

  return hasGalleryPermission(session.gallery_member?.permissions ?? {}, required);
}
